import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
// ACH
const addAchSchema = Yup.object().shape({
  checkingSavingType: Yup.mixed<'CHECKING' | 'SAVINGS'>()
    .oneOf(['CHECKING', 'SAVINGS'])
    .required(i18n.t('payment_methods.ach_required_account_type')),
  personalBusinessType: Yup.mixed<'PERSONAL' | 'BUSINESS'>()
    .oneOf(['PERSONAL', 'BUSINESS'])
    .required(i18n.t('payment_methods.ach_required_account_type')),
  nameOnAccount: Yup.string().required(i18n.t('payment_methods.ach_name_required')),
  accountNumber: Yup.string()
    .required(i18n.t('payment_methods.ach_account_number_required'))
    .matches(/^\d+$/, i18n.t('payment_methods.account_only_digits'))
    .min(4, i18n.t('payment_methods.account_min_length'))
    .max(17, i18n.t('payment_methods.account_max_length')),
  routingNumber: Yup.string()
    .required(i18n.t('payment_methods.ach_routing_number_required'))
    .length(9, i18n.t('mix.exact_length', { LENGTH: 9 }))
});

// BillingAddress
const billingAddressSchema = Yup.object().shape({
  firstName: Yup.string()
    .required(i18n.t('billing_address.name_required'))
    .matches(/^[A-Za-z0-9 .,'&\-]+$/, i18n.t('billing_address.name_validation'))
    .trim()
    .test(
      'is-not-empty-after-trim',
      i18n.t('billing_address.name_required'),
      (value) => !!value && value.trim().length > 0
    ),
  lastName: Yup.string()
    .required(i18n.t('billing_address.surname_required'))
    .matches(/^[A-Za-z0-9 .,'&\-]+$/, i18n.t('billing_address.surname_validation'))
    .trim()
    .test(
      'is-not-empty-after-trim',
      i18n.t('billing_address.surname_required'),
      (value) => !!value && value.trim().length > 0
    ),
  address1: Yup.string().required(i18n.t('billing_address.address_required')),
  // address2: Yup.string(),
  // phoneNumber: Yup.string(),
  email: Yup.string()
    .email(i18n.t('mix.valid_email'))
    .test('no-plus', i18n.t('mix.no_plus_allowed'), (value) => {
      if (!value) return true;
      const [localPart] = value.split('@');
      return !localPart.includes('+');
    })
    .required(i18n.t('mix.required_email')),
  emailConfirmation: Yup.string()
    .oneOf([Yup.ref('email')], i18n.t('mix.match_email'))
    .email(i18n.t('mix.valid_email'))
    .test('no-plus', i18n.t('mix.no_plus_allowed'), (value) => {
      if (!value) return true;
      const [localPart] = value.split('@');
      return !localPart.includes('+');
    })
    .required(i18n.t('mix.required_email_confirmation'))
});

// Types
// ACH
export type AddAchData = Yup.InferType<typeof addAchSchema>;
// BillingAddress
export type BillingAddressData = Yup.InferType<typeof billingAddressSchema>;

// Resolvers
// ACH
export const addAchResolver = yupResolver(addAchSchema);
// BillingAddress
export const billingAddressResolver = yupResolver(billingAddressSchema);
